export default {
  point: "{{count}} pt",
  point_other: "{{count}} pts",
  free: "Gratis",
};
